import { render } from "./About.vue?vue&type=template&id=25c2eaf6&scoped=true"
import script from "./About.vue?vue&type=script&lang=ts"
export * from "./About.vue?vue&type=script&lang=ts"

import "./About.vue?vue&type=style&index=0&id=25c2eaf6&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-25c2eaf6"

export default script